import React from 'react';
import { Container, Row, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';

function Loader({ inline, color = 'primary', size = '' }) {
  return (
    <Container fluid className={!inline ? 'vh-50 d-flex' : ''}>
      <Row className="justify-content-center align-self-center w-100 text-center">
        <Spinner color={color} size={size} />
      </Row>
    </Container>
  );
}

Loader.propTypes = {
  inline: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string,
};

export default Loader;
